import {$qs} from '../../@shared/ts/dom';
import {type IResponse} from '../../@type/response';

declare const peachpay_admin: PeachPayAdminData;

function handleApplePayDomainRegistration(gateway: string) {
	const $button = document.querySelector('#' + gateway + '-verify-apay-button');
	const $spinner = document.querySelector('#' + gateway + '-verify-apay-spinner');
	const $error = document.querySelector('#' + gateway + '-verify-apay-error');

	if (!$button || !$spinner || !$error) {
		return;
	}

	const showSpinner = () => {
		$spinner.classList.remove('hide');
		$button.classList.add('hide');
	};

	const hideSpinner = () => {
		$spinner.classList.add('hide');
		$button.classList.remove('hide');
	};

	const clearError = () => {
		$error.innerHTML = '';
	};

	const setError = (errorMessage: string) => {
		$error.innerHTML = errorMessage;
	};

	$button.addEventListener('click', async () => {
		clearError();
		showSpinner();

		const action = gateway === 'square' ? 'pp-square-applepay-domain-register' : 'pp-stripe-applepay-domain-register';

		const formData = new FormData();

		formData.append('action', action);
		formData.append('security', peachpay_admin.nonces.applepay_domain_register);

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json() as IResponse<void>;

		if (!data.success) {
			hideSpinner();
			setError(data.message ?? '');
			return;
		}

		location.reload();
	});
}

function handleApplePayDomainReset() {
	const $input = $qs<HTMLInputElement>('input.peachpay-applepay-reset');
	if (!$input) {
		return;
	}

	const $container = document.createElement('div');
	$container.classList.add('peachpay');
	$container.classList.add('row');

	const spinnerImageUrl = peachpay_admin.asset_url + 'img/spinner-dark.svg';

	$container.innerHTML = /* html */`
    <button class="button peachpay-applepay-reset-button" type="button" style="height: 1.6rem;">Reset</button>
    <img src="${spinnerImageUrl}" class="peachpay-applepay-reset-spinner hide" style="height: 1.6rem;">
    <span class="peachpay-applepay-reset-error"></span>`;

	const $button = $container.querySelector('.peachpay-applepay-reset-button');
	const $spinner = $container.querySelector('.peachpay-applepay-reset-spinner');
	const $error = $container.querySelector('.peachpay-applepay-reset-error');
	if (!$button || !$spinner || !$error) {
		return;
	}

	const showSpinner = () => {
		$spinner.classList.remove('hide');
		$button.classList.add('hide');
	};

	const hideSpinner = () => {
		$spinner.classList.add('hide');
		$button.classList.remove('hide');
	};

	const clearError = () => {
		$error.innerHTML = '';
	};

	const setError = (errorMessage: string) => {
		$error.innerHTML = errorMessage;
	};

	$button.addEventListener('click', async () => {
		clearError();
		showSpinner();

		const action = $input.dataset['gateway'] === 'peachpay_stripe_applepay' ? 'pp-stripe-applepay-domain-register' : 'pp-square-applepay-domain-register';

		const formData = new FormData();

		formData.append('action', action);
		formData.append('security', peachpay_admin.nonces.applepay_domain_register);

		const response = await fetch(peachpay_admin.admin_ajax, {
			method: 'POST',
			body: formData,
		});

		const data = await response.json() as IResponse<void>;

		if (!data.success) {
			hideSpinner();
			setError(data.message ?? '');
			return;
		}

		location.reload();
	});

	$input.insertAdjacentElement('beforebegin', $container);
}

export {
	handleApplePayDomainRegistration,
	handleApplePayDomainReset,
};
